
import Vue from "vue";
import eventBus from "../event-bus";

export default Vue.extend({
	data() {
		return {
			maxHeightVal: "unset"
		};
	},
	props: {
		up: Boolean,
		maxHeight: {
			type: Number,
			default: 0
		},
		useFlex: Boolean
	},
	computed: {
		style(): any {
			return {
				maxHeight: this.maxHeightVal
			};
		},
		root(): HTMLDivElement {
			return this.$refs.root as HTMLDivElement;
		}
	},
	methods: {
		update(correction?: boolean) {
			let rect = this.root.getBoundingClientRect();
			if (!this.up) {
				let pageHeight = window.innerHeight;
				var maxHeight = (pageHeight - rect.top);
			} else {
				var maxHeight = (rect.bottom);
			}
			if (this.maxHeight > 0 && this.maxHeight < maxHeight) {
				this.maxHeightVal = this.maxHeight + "px";
			} else {
				this.maxHeightVal = maxHeight + "px";
			}
			if (!correction) {
				requestAnimationFrame(() => {
					this.update(true);
				});
			}
		},
		updateEvent(){
			this.update(false);
		}
	},
	mounted() {
		eventBus.$on("window-resize", this.update);
		window.addEventListener("scroll", this.updateEvent, true);
		this.update();
	},
	destroyed() {
		eventBus.$off("window-resize", this.update);
		window.removeEventListener("scroll", this.updateEvent, true);
	},
});
